import { Button, EpicIcons } from "@constellation-academy/epic-ui";
import React from "react";
import { graphql, useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type CreateMarkMistakeElementButton_CreateMarkMistakeElementMutation } from "@relay/CreateMarkMistakeElementButton_CreateMarkMistakeElementMutation.graphql";
import { useDraftStatusUpdater } from "./use-draft-status-updater";

const CREATE_MARK_MISTAKE_ELEMENT_MUTATION = graphql`
	mutation CreateMarkMistakeElementButton_CreateMarkMistakeElementMutation(
		$input: CreateMarkMistakesElementInput!
	) {
		Admin {
			ElearningV2 {
				createMarkMistakesElement(input: $input) {
					eLearningContent {
						...contentCard_TreeNodeFragment
					}
				}
			}
		}
	}
`;

type OwnProps = {
	eLearningContentNodeId: string;
};

export const CreateMarkMistakeElementButton = ({ eLearningContentNodeId }: OwnProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();
	const [createMarkMistakeElement, isCreatingMarkMistakeElement] =
		useMutation<CreateMarkMistakeElementButton_CreateMarkMistakeElementMutation>(
			CREATE_MARK_MISTAKE_ELEMENT_MUTATION,
		);
	return (
		<Button
			disabled={isCreatingMarkMistakeElement}
			tooltip={t("educationalOffer.createMarkMistakeElementTooltip")}
			icon={EpicIcons.CHECK_CIRCLE}
			onClick={() => {
				createMarkMistakeElement({
					variables: {
						input: {
							title: t("educationalOffer.newElement"),
							text: "",
							eLearningContentId: eLearningContentNodeId,
						},
					},
					updater: setDraft,
				});
			}}
		/>
	);
};
